import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import LoadingSpinner from '../partials/LoadingSpinner';
import { Button, Text, Panel, Switch, H3, H4, Dropdown, Fieldset, FormGroup, Radio, Table, Box } from '@bigcommerce/big-design';
import { AddIcon, ArrowDropDownIcon, DeleteIcon, EditIcon } from '@bigcommerce/big-design-icons';

import { paymentTermsIndex } from '../../redux/actions/paymentTerms';

const PaymentTerms = ({ payload, settings, submitSettings, loadPaymentTerms, paymentTerms, setShowNewPaymentTermModal, setActivePaymentTerm, setShowEditPaymentTermModal, setShowDisablePaymentTermModal }) => {
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    loadPaymentTerms(payload);
  }, []);

  const edit = (id) => {
    let activeTerm = paymentTerms.paymentTerms.find(term => term.id === id);
    setActivePaymentTerm(activeTerm);
    setShowEditPaymentTermModal(true);
  }

  const disable = (id) => {
    let activeTerm = paymentTerms.paymentTerms.find(term => term.id === id);
    setActivePaymentTerm(activeTerm);
    setShowDisablePaymentTermModal(true);
  }

  const setDropdownValue = (setField, value) => {
    setField(value);
  }

  const paymentTermsItems = () => {
    let items = [];

    paymentTerms.paymentTerms.map(paymentTerm => 
      items.push(
        {
          content: paymentTerm.term_name,
          onItemClick: () => setDropdownValue(setActivePaymentTerm, paymentTerm),
          hash: paymentTerm.id
        }
      )
    )

    return items;
  }

  return(
    <Panel>
      <H3>Payment Terms</H3>
      { paymentTerms.status !== 'success' &&
        <LoadingSpinner statusText="Loading Payment Terms"/>
      }
      { paymentTerms.status === 'success' && paymentTerms.paymentTerms.length > 0 &&
        <>
          <Table
            columns={[
              { header: 'Name', hash: 'term_name', render: ({ term_name }) => term_name },
              { header: 'Period', hash: 'shipping_terms', render: ({ shipping_terms }) => shipping_terms },
              { header: 'Actions', hash: 'id', render: ({ id }) => 
                <>
                  <Button
                    onClick={() => edit(id)}
                    variant="subtle"
                    iconLeft={<EditIcon />}
                  >
                    Edit
                  </Button> 
                  <Button 
                    onClick={() => disable(id)}
                    variant="subtle"
                    actionType="destructive"
                    iconLeft={<DeleteIcon />}
                  >
                    Disable
                  </Button> 
                </>
              },
            ]}
            items={paymentTerms.paymentTerms}
          />

          <Button
            iconLeft={<AddIcon />}
            onClick={() => setShowNewPaymentTermModal(true)}
            variant="secondary"
          >
            New Payment Term
          </Button>
        </>
      }
      { paymentTerms.status === 'success' && paymentTerms.paymentTerms.length === 0 &&
        <Box
          backgroundColor="warning10"
          border="box"
          borderRadius="normal"
          padding="medium"
        >
          <div className="text-center">
            <Text>No payment terms set. Create payment terms to see them here.</Text>
            <Button
              iconLeft={<AddIcon />}
              onClick={() => setShowNewPaymentTermModal(true)}
              variant="secondary"
            >
              New Payment Term
            </Button>
          </div>
        </Box>
      }
    </Panel>
  )
}

const mapStateToProps = state => ({
  settings: state.settings.settings,
  paymentTerms: state.paymentTerms,
});

const mapDispatchToProps = (dispatch) => ({
  submitSettings: (payload, newSettings) => dispatch(updateSettings(payload, newSettings)),
  loadPaymentTerms: (payload) => dispatch(paymentTermsIndex(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentTerms);